import { Device } from '@capacitor/device'
import { Gate1 } from './nativeBridge'
import { parseUserAgent } from './core/ua'

// Device, OS, WebView and screen facts for the run logs.
export async function collectDeviceInfo() {
    const [dev, native] = await Promise.all([
        Device.getInfo().catch(e => ({ error: String(e) })),
        Gate1.getInfo().catch(e => ({ error: String(e) })),
    ])
    const ua = navigator.userAgent
    const parsed = parseUserAgent(ua)
    return {
        device: {
            model: native.model ?? dev.model ?? null,
            manufacturer: native.manufacturer ?? dev.manufacturer ?? null,
            platform: dev.platform ?? native.platform ?? null,
            operatingSystem: dev.operatingSystem ?? null,
            osVersion: dev.osVersion ?? parsed.osVersion ?? null,
            // Android: the WebView package's own version. iOS: WKWebView ships
            // with the OS, so its version is the OS/Safari version in the UA.
            webViewVersion: native.webViewVersion ?? dev.webViewVersion ?? parsed.engineVersion ?? null,
            webViewPackage: native.webViewPackage ?? null,
            sdkInt: native.sdkInt ?? null,
            socModel: native.socModel ?? null,
            isVirtual: dev.isVirtual ?? null,
            userAgent: ua,
            userAgentParsed: parsed,
            displayRefreshHz: native.displayRefreshHz ?? null,
            displaySupportedHz: native.displaySupportedHz ?? null,
        },
        native,
    }
}

export function screenInfo() {
    return {
        width: window.screen.width,
        height: window.screen.height,
        availWidth: window.screen.availWidth,
        availHeight: window.screen.availHeight,
        innerWidth: window.innerWidth,
        innerHeight: window.innerHeight,
        devicePixelRatio: window.devicePixelRatio,
        orientation: window.screen.orientation?.type ?? null,
    }
}
